const STORAGE_KEY = 'buyer_intent_distinct_id';

function generateId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `bi-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

function read() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (_error) {
    return null;
  }
}

function store(value) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch (_error) {
    return;
  }
}

export function createIdentityManager() {
  let distinctId = null;

  function ensure() {
    if (distinctId) {
      return distinctId;
    }

    const stored = read();
    if (stored) {
      distinctId = stored;
      return stored;
    }

    const generated = generateId();
    distinctId = generated;
    store(generated);
    return generated;
  }

  function set(value) {
    if (value) {
      distinctId = value;
      store(value);
    }
  }

  function get() {
    return distinctId;
  }

  return { ensure, set, get };
}
